// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"edb09467","84":"4f5476bc","358":"c8637106","611":"1ad27c7a"}[chunkId] + ".chunk.css";
};